module.exports = __webpack_public_path__ + "img/32.351581be.png";